import React, { useState } from 'react';
import {
    Link
} from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Burger = () => {

    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => setIsOpen(!isOpen);

    if(isOpen) {
        return(
            <div>
                <div className="Burger">
                    <span className="Burger__button" onClick={toggle}><FontAwesomeIcon icon={['fas','times']}  size="3x"/></span>
                </div>
                <nav className="Nav">
                    <ul>
                    <Link to="/"><li className="Nav__Element Special"><FontAwesomeIcon icon={['fas','home']}  size="lg"/></li></Link>
                        <Link to="/about"><li className="Nav__Element">About</li></Link>
                        <a href="https://twitter.com/_m0rtega" target="_blank" rel="noreferrer"><li className="Nav__Element"><FontAwesomeIcon icon={['fab', 'twitter']}  size="lg"/></li></a>
                        <a href="https://www.linkedin.com/in/angel-martin-ortega-yung-a93a9a1ab/" target="_blank" rel="noreferrer"><li className="Nav__Element"><FontAwesomeIcon icon={['fab', 'linkedin']}  size="lg"/></li></a>
                        <a href="https://github.com/m0rtega" target="_blank" rel="noreferrer"><li className="Nav__Element"><FontAwesomeIcon icon={['fab', 'github']} size="lg"/></li></a>
                        <a href="/CMO.pdf" download="Curriculum_Martin_Ortega.pdf"><li className="Nav__Element">Download CV</li></a>
                    </ul>
                </nav>
            </div>
        )
    } else {
        return(
            <div className="Burger">
                <span className="Burger__button" onClick={toggle}><FontAwesomeIcon icon={['fas','bars']}  size="3x"/></span>
            </div>
        )
    } 
}

const Header = () => {
    return(
        <div className="Header">
            <Link className="Header__Title" to="/">
                M. Ortega</Link>
            <Burger></Burger>
            <div className="Header__Menu">
                <Link className="Header__Element" to="/"><FontAwesomeIcon icon={['fas','home']}  size="lg"/></Link>
                <Link className="Header__Element" to="/about">About</Link>
                {/*<Link className="Header__Element" to="/contact">Contact</Link>*/}
                <a className="Header__Element" href="https://twitter.com/_m0rtega" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={['fab', 'twitter']}  size="lg"/></a>
                <a className="Header__Element" href="https://www.linkedin.com/in/angel-martin-ortega-yung-a93a9a1ab/" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={['fab', 'linkedin']}  size="lg"/></a>
                <a className="Header__Element" href="https://github.com/m0rtega" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={['fab', 'github']} size="lg"/></a>
                <a className="Header__Element" href={process.env.PUBLIC_URL + "/CMO2.pdf"} download="Curriculum_Martin_Ortega.pdf">Download CV</a>
            </div>
        </div>
    )
}



export default Header;